import React from 'react'

const Usuarios = () => {
  return (
    <div>Usuarios</div>
  )
}

export default Usuarios